const gradientClasses = {
  brand:
    "bg-[linear-gradient(120deg,var(--color-azure)_0%,var(--color-cerulean)_60%,var(--color-cobalt)_100%)]",
  azureBlue: "bg-grad-blue",
  coral: "bg-grad-coral",
};

/**
 * Inline span with a clipped gradient text fill.
 *
 * @param {Object} props
 * @param {import("react").ReactNode} props.children - text content
 * @param {"brand" | "azureBlue" | "coral"} [props.gradient] - gradient preset, defaults to brand
 * @param {string} [props.className] - extra classes
 * @returns {import("react").ReactElement}
 */
export function GradientText(props) {
  const { children, gradient = "brand", className = "" } = props;

  return (
    <span
      className={`bg-clip-text text-transparent ${gradientClasses[gradient]} ${className}`.trim()}
    >
      {children}
    </span>
  );
}
